import React from 'react'
import { useTranslation } from 'react-i18next'

import AddFacebookPage from './FacebookPagesForms/AddFacebookPage'
import RequestPageAccess from './FacebookPagesForms/RequestPageAccess'
import AccessibleSocialPagesList from '../AccessibleSocialPagesList'
import SocialAuthChecker from '../../../../features/components/SocialAuthChecker'
import FacebookBusinessManagementScopeChecker from '../../../../features/components/SocialAuthChecker/FacebookBusinessManagementScopeChecker'

import { FACEBOOK_PLATFORM, FACEBOOK_PROVIDER_PLATFORM } from '../../../../constants/selectLists/platformList'

import useCommonStyles from '../../../../styles/common/listPage'

const FacebookPages = () => {
  const commonClasses = useCommonStyles()

  const { t } = useTranslation()

  return (
    <div className={commonClasses.pageSection}>
      <div className={commonClasses.heading}>
        <div className={commonClasses.subTitle}>{t(`Facebook Pages`)}</div>
        <p>
          {t(
            'Facebook ads are always linked to a page. Here you can add Facebook pages that users of this partnership can use to create ads.'
          )}
        </p>
        <SocialAuthChecker
          platform={FACEBOOK_PLATFORM}
          authFailureText="Please authenticate with Facebook to add a page"
          contentAlign="left"
          hasPadding={false}
        >
          <FacebookBusinessManagementScopeChecker>
            <div className={commonClasses.formButtons}>
              <AddFacebookPage />
              <RequestPageAccess />
            </div>
          </FacebookBusinessManagementScopeChecker>
        </SocialAuthChecker>
      </div>
      <AccessibleSocialPagesList platformProvider={FACEBOOK_PROVIDER_PLATFORM} />
    </div>
  )
}

export default FacebookPages
